import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Stack,
  Text,
} from '@chakra-ui/react';
import { useState } from 'react';
import type { CreateStoreGroupPayload } from 'services/interfaces/storeGroup';

interface CreateStoreGroupModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (payload: CreateStoreGroupPayload) => void;
  submitting: boolean;
}

const CreateStoreGroupModal: React.FC<CreateStoreGroupModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  submitting,
}) => {
  const [name, setName] = useState('');

  const handleClose = () => {
    if (submitting) return;
    setName('');
    onClose();
  };

  const handleSubmit = () => {
    if (!name.trim()) return;
    onConfirm({ name: name.trim(), type: 'CASHBACK' });
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered>
      <ModalOverlay />
      <ModalContent mx={3}>
        <ModalHeader>Novo grupo de lojas</ModalHeader>
        <ModalCloseButton isDisabled={submitting} />
        <ModalBody>
          <Stack spacing={4}>
            <FormControl isRequired>
              <FormLabel>Nome do grupo</FormLabel>
              <Input
                value={name}
                isDisabled={submitting}
                onChange={(e) => setName(e.target.value)}
                placeholder="Ex.: Rede Centro-Oeste"
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>Tipo</FormLabel>
              {/* Genérico por design — só CASHBACK está implementado por enquanto (fatia 1). */}
              <Select value="CASHBACK" isDisabled>
                <option value="CASHBACK">Cashback</option>
              </Select>
              <Text fontSize="xs" color="gray.500" mt={1}>
                Fidelidade e voucher ainda não estão disponíveis.
              </Text>
            </FormControl>
          </Stack>
        </ModalBody>
        <ModalFooter gap={2}>
          <Button variant="ghost" onClick={handleClose} isDisabled={submitting}>
            Cancelar
          </Button>
          <Button
            colorScheme="yooga"
            onClick={handleSubmit}
            isLoading={submitting}
            isDisabled={!name.trim()}
          >
            Criar grupo
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CreateStoreGroupModal;
